"use client"
import { Popup } from "react-map-gl/mapbox";

import "@/components/shared/MapBoxMapPopup.css";

const MapBoxMapPopup = ({ latitude, longitude, anchor = "bottom", closeOnClick = false, children }) => {
  return (
    <>
      <Popup longitude={longitude} latitude={latitude} anchor={anchor} closeOnClick={closeOnClick}>
        <div className="mapbox-map-popup">{children}</div>
      </Popup>
    </>
  );
};
export default MapBoxMapPopup;
